export default __webpack_public_path__ + "static/media/sorry.e625d21c.jpg";